import { QUESTION_DRILLDOWN } from '../../../constants';

export default function isValid(question, answers = []) {
  if (question.style !== QUESTION_DRILLDOWN) {
    return true;
  }

  const isEveryGivenAnswerWithinQuestion = answers.every((answer) =>
    question.answers.find(({ refId }) => answer.refId === refId),
  );
  if (!isEveryGivenAnswerWithinQuestion) {
    // this should be removed from here in order to make this side-effect-free
    Pollfish.ui.prompt(Pollfish.ui.getText('warnings.multiple'));
  }
  return isEveryGivenAnswerWithinQuestion;
}
